import app from 'firebase/app';
import 'firebase/database';

const config = {
	apiKey: process.env.REACT_APP_API_KEY,
	authDomain: process.env.REACT_APP_AUTH_DOMAIN,
	databaseURL: process.env.REACT_APP_DATABASE_URL,
	projectId: process.env.REACT_APP_PROJECT_ID,
	storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
	messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
	appId: process.env.REACT_APP_APP_ID,
};

class Firebase {
	constructor() {
		this.app = app.initializeApp(config);
		this.db = app.database();
	}

	roomById(id) {
		return this.db.ref(`rooms/${id}`);
	}

	createNewRoom() {
		// Get a key for a new Room.
		const newRoomKey = this.db.ref().child('rooms').push().key;

		// A room entry.
		const roomData = {
			inUse: false,
			linkCode: 'H39V',
			timeMade: new Date().toUTCString(),
			direction: 0,
			mode: '',
		};

		const updates = {};
		updates[`/rooms/${newRoomKey}`] = roomData;

		this.db.ref()
			.update(updates)
			.then((r) => {
				console.log(r);
			});

		return this.roomById(newRoomKey);
	}
}

export default Firebase;
